import { initialize, isAvailable, isFeatureEnabled, whenAvailable } from '@vp/ab-reader';

import { isProAdvantageCustomer, proAdvLocales } from './utils/app-utils/pro-adv-utils';
import { initNR, logNR } from './utils/app-utils/nr-logging';
import { addOpenChatEventListener } from './utils/sf-utils/chat-actions';
import { getChatConfig, initChatConfig } from './utils/app-utils/chat-config-utils';
import { initTranslations } from './utils/app-utils/translations';
import { WindowType } from './types/global-window-type';
import { initCA, initCAfromExternalSource } from './miaw-main';
import { IInitChatAnywhereProps, ubikEnabledPages } from '../ubik-config';
import { isChatSessionActive } from './utils/sf-utils/chat-session';
import { isStudioPage } from './utils/app-utils/page-specific-utils';

declare const window: WindowType;

/** Code Execution starts here */
export const initChatWithMIAW = (data: IInitChatAnywhereProps, scriptMode?: boolean) => {
  try {
    /** When ab library is ready  */
    if (!isAvailable) initialize();
    whenAvailable(() => {
      const isSessionActive = isChatSessionActive();

      const chatbotEnabledLocales = ['en-au', 'en-ca'];

      const chatbotUBIKEnabled = isFeatureEnabled('ca-chatbot-ubik');
      /** Disable chat for chatbot */
      if (
        chatbotUBIKEnabled && // Feature flag for chatbot UBIK
        chatbotEnabledLocales.includes(data?.locale?.toLowerCase())
      ) {
        return;
      }

      let isEnabled = false;
      ubikEnabledPages.forEach((page) => {
        if (data.pageName && data.pageName?.toLowerCase()?.includes(page?.toLowerCase())) isEnabled = true;
      });

      if (isEnabled || isSessionActive || scriptMode) {
        // Use this variable to prevent multiple load of script
        if (!window.chatLoaded) {
          window.chatLoaded = true;
          initChatConfig(data.locale);
          initTranslations().then(() => {
            /** Add event listener for external src  */
            initCAfromExternalSource();
            addOpenChatEventListener();
            window.isChatNowClicked = false;
            window.isMiawChatReady = false;

            const { locale } = getChatConfig();
            /** Check for ProAdv users */
            const isUserProAdvantage = isProAdvantageCustomer();
            if (!isUserProAdvantage || proAdvLocales.includes(locale)) {
              /** Chat for studio will be loaded through event */
              if (isStudioPage() && !isSessionActive) {
                return;
              }
              /** Init NR , set CA log key */
              initNR();
              /** Init CA code */
              initCA();
            }
          });
        }
      }
    }, 1000);
  } catch (error) {
    const e = error as Error;
    console.error('Error in CA init', e);
    logNR('CA_ERROR', { errorMessage: e.message, errorStack: e.stack });
  }
};
